import Noty from 'noty'
import 'noty/lib/noty.css'

const appNoty = (text, type, modal = false) => {
  if (type == 'notice') {
    type = 'success'
  } else if (type == 'alert') {
    type = 'warning'
  }
  return new Noty({
    type: type || 'warning',
    text: text,
    layout: 'topCenter',
    timeout: 3000,
    progressBar: false,
    modal: modal,
    theme: 'semanticui',
    closeWith: ['button', 'click']
  })
}

export default appNoty
